module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-emails"
  }, [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Email Activity")]), _vm._v(" "), _c('module-spinner', {
    attrs: {
      "active": _vm.loading,
      "floating": true
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.emailActivityLength > 0) ? _c('div', {
    key: "emails-table"
  }, [_c('module-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.emailActivity.results
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-emails__more"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Showing "), _c('strong', [_vm._v(_vm._s(_vm.emailActivityLength))]), _vm._v(" of "), _c('strong', [_vm._v(_vm._s(_vm.emailActivityTotal))]), _vm._v(" Results")]), _vm._v(" "), (_vm.emailActivity.next) ? _c('module-button', {
    attrs: {
      "button": "primary",
      "label": "Load more",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNextPage($event)
      }
    }
  }) : _vm._e()], 1)], 1) : (_vm.emailActivityLength === 0 && !_vm.loading) ? _c('p', {
    staticClass: "fw-bold mt2"
  }, [_vm._v("No Email Activity")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-755f9d2c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/EmailActivity.vue
// module id = 359
// module chunks = 0